/* Settings → Appearance: Light / Dark / System (every role; see lib/theme.ts). Saved on this device only. Light or Dark
   sets data-theme on <html> (style.css has both palettes); System removes it and follows the device, live. The
   theme-color tags (the installed app's title bar) follow too. index.html applies the saved choice before the first
   paint, also when the app opens offline. */
import {THEME_KEY, parseTheme, effectiveTheme, storedTheme, THEME_COLOR, type Theme} from '../lib/theme.ts';

export function theme(): Theme { try { return parseTheme(localStorage.getItem(THEME_KEY)); } catch { return 'system'; } }
const deviceLight = () => { try { return matchMedia('(prefers-color-scheme: light)').matches; } catch { return false; } };
export function applyTheme() {
  const t = theme(), root = document.documentElement;
  if (t === 'system') root.removeAttribute('data-theme'); else root.setAttribute('data-theme', t);
  const c = THEME_COLOR[effectiveTheme(t, deviceLight())];
  document.querySelectorAll('meta[name="theme-color"]').forEach(m => m.setAttribute('content', c));
}
export function setTheme(t: Theme) {
  try { const v = storedTheme(t); if (v === null) localStorage.removeItem(THEME_KEY); else localStorage.setItem(THEME_KEY, v); } catch { /* private mode */ }
  applyTheme();
}
/** start (main.ts, once): apply, and follow the device while System is chosen */
export function installTheme() {
  applyTheme();
  try { matchMedia('(prefers-color-scheme: light)').addEventListener('change', applyTheme); } catch { /* old browser */ }
}

const LABEL: Record<Theme, string> = {light: 'Light', dark: 'Dark', system: 'System'};
export function themeCard(): string {
  const cur = theme();
  return `<div class="card" id="themeCard">
    <h2>Appearance</h2>
    <div class="theme-pick" role="group" aria-label="Appearance">${(['light', 'dark', 'system'] as Theme[]).map(t =>
      `<button type="button" class="chip ${t === cur ? 'on' : ''}" data-theme-pick="${t}" aria-pressed="${t === cur}">${LABEL[t]}</button>`).join('')}</div>
    <p class="muted-text" style="margin-top:8px;">System follows this phone's or computer's own light or dark setting. Saved on this device.</p>
  </div>`;
}
export function wireThemeCard() {
  document.querySelectorAll<HTMLButtonElement>('#themeCard [data-theme-pick]').forEach(b => b.onclick = () => {
    const t = parseTheme(b.dataset.themePick);
    setTheme(t);
    document.querySelectorAll<HTMLButtonElement>('#themeCard [data-theme-pick]').forEach(x => {
      const on = x.dataset.themePick === t; x.classList.toggle('on', on); x.setAttribute('aria-pressed', String(on));
    });
  });
}
